import { CurrentInternalUserQuery, useCurrentInternalUserQuery } from "src/queries/user.generated";
import { SimpleKeys } from "src/utils";

export function useCurrentUser(): SimpleKeys<NonNullable<CurrentInternalUserQuery["currentInternalUser"]>> {
  const { data } = useCurrentInternalUserQuery({ fetchPolicy: "cache-first" });
  return data?.currentInternalUser! || {};
}
